@if (isVideo || showMediaLoading) {
  <mat-card appearance="outlined" class="mat-card-video">
    <mat-card-content>
      @if (showMediaLoading) {
        <div class="encoding-placeholder">
          <div class="encoding-shimmer"></div>
          <div class="encoding-status">
            <mat-icon class="encoding-icon">hourglass_top</mat-icon>
            <span i18n="@@home.videoCard.label.encodingNotReady">動画の準備中です...</span>
          </div>
        </div>
      } @else {
      @if (isPrepared) {
      <ng-container i18n="@@home.videoCard.message.videoNotUploaded">動画がアップロードされていません</ng-container>
      }
      @if (isUploading) {
        <div class="encoding-placeholder">
          <div class="encoding-shimmer"></div>
          <div class="encoding-status">
            <mat-icon class="encoding-icon">hourglass_top</mat-icon>
            <span i18n="@@home.videoCard.label.encoding">エンコード中...</span>
          </div>
        </div>
      }
      @if (isDeletedStatus) {
        <div class="encoding-placeholder">
          <div class="encoding-status">
            <mat-icon class="encoding-icon">delete_outline</mat-icon>
            <span i18n="@@home.videoCard.label.deleted">削除されました</span>
          </div>
        </div>
      }
      @if (isErrorStatus) {
        <div class="encoding-placeholder">
          <div class="encoding-status">
            <mat-icon class="encoding-icon error-icon">error_outline</mat-icon>
            <span i18n="@@home.videoCard.label.statusError">エラーが発生しました</span>
          </div>
        </div>
      }
      @if (isEncoded) {
        @if (snapshotLoading) {
          <!-- ローディング中（準備中 / 404 リトライ中）は再生意図の有無に関わらず常にスピナーを出す。
               サムネがあれば（中身が黒でも）その上に、無ければ shimmer 背景の上にスピナーを重ねる。 -->
          @if (showVideoThumbnail) {
            <div class="video-thumbnail-placeholder">
              <img
                class="video-thumbnail"
                [src]="videoThumbnailUrl"
                (error)="onVideoThumbnailError()"
                alt="" />
              <div class="startup-spinner-overlay">
                <span class="overlay-spinner" aria-hidden="true"></span>
              </div>
            </div>
          } @else {
            <div class="encoding-placeholder">
              <div class="encoding-shimmer"></div>
              <div class="startup-spinner-overlay">
                <span class="overlay-spinner" aria-hidden="true"></span>
              </div>
            </div>
          }
        }
        @if (snapshotLoadFailed) {
          <div class="encoding-placeholder">
            <div class="encoding-status">
              <mat-icon class="encoding-icon error-icon">error_outline</mat-icon>
              <span i18n="@@home.videoCard.label.loadFailed">動画の読み込みに失敗しました</span>
              <span class="error-detail" i18n="@@home.videoCard.label.retryLater">しばらく時間をおいて再度お試しください</span>
            </div>
          </div>
        }
        <div class="video-shell" #videoShell [class.video-shell--floating]="showFloatingPlayer">
          <div class="video-wrapper" #videoWrapper
            [class.playing]="snapshotPlaying"
            [class.starting]="snapshotPlaybackStarting"
            [class.hidden]="!snapshotReady"
            [class.floating]="showFloatingPlayer"
            [class.floating--positioned]="showFloatingPlayer && floatingPos"
            [style.left.px]="showFloatingPlayer && floatingPos ? floatingPos.left : null"
            [style.top.px]="showFloatingPlayer && floatingPos ? floatingPos.top : null"
            [style.width.px]="showFloatingPlayer && floatingWidth ? floatingWidth : null"
            (pointerdown)="showFloatingPlayer && onFloatingPointerDown($event)"
            (pointermove)="showFloatingPlayer && onFloatingPointerMove($event)"
            (pointerup)="showFloatingPlayer && onFloatingPointerUp($event)"
            (pointercancel)="showFloatingPlayer && onFloatingPointerUp($event)">
            <div class="video-container" #videoHost></div>
            @if (showVideoThumbnail) {
              <img
                class="video-thumbnail video-thumbnail--overlay"
                [src]="videoThumbnailUrl"
                (error)="onVideoThumbnailError()"
                alt="" />
            }
            @if (!disableCustomOverlay) {
              <div class="video-overlay">
                <div class="overlay-top"></div>
                <div class="overlay-center" [class.paused]="!snapshotPlaying || isEnded">
                  <button class="overlay-btn skip-btn"
                    [disabled]="snapshotPlaybackStarting"
                    (click)="seekRelative(-10)" aria-label="10秒戻る" i18n-aria-label="@@home.videoCard.ariaLabel.rewind10">
                    <mat-icon>replay_10</mat-icon>
                  </button>
                  <button class="overlay-btn primary"
                    [disabled]="snapshotPlaybackStarting"
                    [attr.aria-busy]="snapshotPlaybackStarting"
                    (click)="videoPlayToggle.emit()" aria-label="再生/一時停止" i18n-aria-label="@@home.videoCard.ariaLabel.playPause">
                    @if (snapshotPlaybackStarting) {
                      <span class="overlay-spinner" aria-hidden="true"></span>
                    } @else {
                      <mat-icon [class.replay-spin]="replaySpin">
                        {{ isEnded ? 'replay' : (snapshotPlaying ? 'pause' : 'play_arrow') }}
                      </mat-icon>
                    }
                  </button>
                  <button class="overlay-btn skip-btn"
                    [disabled]="snapshotPlaybackStarting"
                    [style.visibility]="isEnded ? 'hidden' : 'visible'"
                    (click)="seekRelative(10)" aria-label="10秒進む" i18n-aria-label="@@home.videoCard.ariaLabel.forward10">
                    <mat-icon>forward_10</mat-icon>
                  </button>
                </div>
                <div class="overlay-bottom">
                  <span class="time-label">{{ formatTime(displayCurrentTimeForUi) }} / {{ formatTime(snapshotDisplayDuration) }}</span>
                  <div class="controls-inline">
                    <button class="overlay-btn text-button"
                      (click)="cycleRate()" aria-label="再生速度を切り替え" i18n-aria-label="@@home.videoCard.ariaLabel.cycleRate">
                      x{{ snapshotPlaybackRate | number:'1.0-2' }}
                    </button>
                    <button class="overlay-btn icon-plain"
                      (click)="videoMuteToggle.emit()" aria-label="ミュート切替" i18n-aria-label="@@home.videoCard.ariaLabel.muteToggle">
                      <mat-icon>{{ snapshotMuted ? 'volume_off' : 'volume_up' }}</mat-icon>
                    </button>
                    <button class="overlay-btn icon-plain"
                      [disabled]="showFloatingPlayer"
                      (click)="toggleFullscreen()" aria-label="全画面" i18n-aria-label="@@home.videoCard.ariaLabel.fullscreen">
                      <mat-icon>{{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            }
            @if (showFloatingPlayer) {
              <span class="floating-resize-handle floating-resize-handle--tl"
                role="separator"
                aria-label="サイズ変更"
                i18n-aria-label="@@home.videoCard.ariaLabel.resizeMiniPlayer"
                (pointerdown)="onResizePointerDown($event, 'tl')"
                (pointermove)="onResizePointerMove($event)"
                (pointerup)="onResizePointerUp($event)"
                (pointercancel)="onResizePointerUp($event)"></span>
              <button class="floating-dismiss"
                (click)="dismissFloatingPlayer()"
                aria-label="ミニプレイヤーを閉じる"
                i18n-aria-label="@@home.videoCard.ariaLabel.dismissMiniPlayer">
                <mat-icon>close</mat-icon>
              </button>
            }
            <div class="video-seekbar" aria-hidden="true">
              <div class="video-seekbar__filled" [style.width.%]="progressPercent"></div>
            </div>
          </div>
        </div>
      }
      @if (showWaveCard) {
        <div class="vs-wave-inline">
          <app-measured-data-wave-card
            [frameless]="true"
            [recordData]="waveRecordData"
            [recordtype]="waveRecordType"
            [recordLoadingSuccess]="recordLoadingSuccess"
            [waveProcessing]="waveProcessing"
            [waveDownloading]="waveDownloading"
            [waveDownloadPercent]="waveDownloadPercent"
            [waveLoadingPercent]="waveLoadingPercent"
            [waveErrorMessage]="waveErrorMessage"
            [selectedEvent]="selectedEvent"
            [currentStartOffset]="currentStartOffset"
            [playing]="playing"
            [timelineOffsetReference]="timelineOffsetReference"
            [zoomValue]="zoomValue"
            (offsetToggle)="offsetToggle.emit($event)"
            (seek)="seek.emit($event)"
            (playPauseClicked)="playPauseClicked.emit()"
            (zoomMinusClicked)="zoomMinusClicked.emit()"
            (zoomResetClicked)="zoomResetClicked.emit()"
            (zoomPlusClicked)="zoomPlusClicked.emit()">
          </app-measured-data-wave-card>
        </div>
      }
      <div class="card-video-comment-content">
        <p>{{ mediaRecordData?.data?.comment }}</p>
      </div>
      }
    </mat-card-content>
  </mat-card>
}
